import React from 'react';

function Footer() {
  const footerStyle = {
    textAlign: 'center',
    color: '#A4A6A9',
    padding: '20px 0',
    marginTop: '20px',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '1.2',
  };

  return (
    <footer style={footerStyle}>
      <p>Weather data provided by Weatheri, Inc</p>
      <p>Powered by NAMOWEBIZ, Inc.</p>
    </footer>
  );
};

export default Footer;
